import { FC, ReactNode } from 'react';
import { Logo } from './Header/Logo';
import styles from './RoutePendingLayout.module.css';

const RoutePendingLayout: FC = (): ReactNode => {
  return (
    <div className={styles.container} aria-busy="true" aria-live="polite">
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.logoContainer}>
            <Logo />
          </div>
          <div className={styles.headerActions}>
            <div className={styles.headerActionSkeleton} />
            <div className={styles.headerActionSkeleton} />
          </div>
          <div className={styles.logoutSkeleton} />
        </div>
      </header>
      <main className={styles.main}>
        <aside className={styles.aside}>
          <div className={styles.navCard}>
            <div className={styles.navTitle} />
            <div className={styles.navLine} />
            <div className={styles.navLine} />
            <div className={styles.navLine} />
          </div>
        </aside>
        <section className={styles.content}>
          <div className={styles.titleLine} />
          <div className={styles.bodyLine} />
          <div className={styles.bodyLine} />
          <div className={styles.bodyLineShort} />
        </section>
      </main>
    </div>
  );
};

export default RoutePendingLayout;
